<div *ngIf="!noData" class="flex-container">
  <div class="w-100">
    <div class="grid-container-mutliple-v2">
      <div [ngSwitch]="selViewSwitcherOption" class="pheriperal-container-style">
        <div class="d-grid align-items-center grid-column mb-2 ">
          <h2 class="m-0 fs-6 perepheral-title">Availability</h2>
          <app-view-switcher class="place-right" [options]="viewSwitcherOptions" [showOnlyInactive]="true"
            (select)="onViewSwitcherSelect($event);">
          </app-view-switcher>
        </div>

        <div class="responsive-class breakpoint-columns" *ngSwitchCase="VIEW_TYPE.TILE_VIEW">
          <app-peripheral-topic-item class="h-100 d-grid" *ngFor="let peripheral of peripheralMetrics?.series"
            [content]="peripheral" (blockClick)="onBlockClick($event)">
          </app-peripheral-topic-item>
        </div>

        <div class="grid-container-single" *ngSwitchCase="VIEW_TYPE.TREE_VIEW">
          <app-tree [series]="peripheralTreeSeries" [merge]="peripheralTreeSeriesUpdate"
            [autoResize]="peripheralTreeAutoResize" [tooltip]="peripheralTreeTooltipOption"
            [dispatchAction]="peripheralDispatchAction" [cursor]="peripheralTreeCursor"
            (chartClick)="onTreeChartClick($event)">
          </app-tree>
        </div>
      </div>
      <div>
        <div class="py-2 px-4 m-1 bg-white box-shadow-left rounded-1 history-window-width">
          <div class="fs-6 d-flex align-items-center gap5">
            <h1 class="perepheral-title">History</h1>
            <ng-container *ngIf="selPeripheral?.title">
              <span class="periperal-title"> | {{ selPeripheral?.title | titlecase }}</span>
            </ng-container>
          </div>
          <app-history-list [list]="peripheralHistory" [name]="selPeripheral?.title"></app-history-list>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="noData" class="text-center p-20-px">
  <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="no data">
</div>